import { render, staticRenderFns } from "./SubTasks.vue?vue&type=template&id=af9e95c2&"
import script from "./SubTasks.vue?vue&type=script&lang=js&"
export * from "./SubTasks.vue?vue&type=script&lang=js&"
import style0 from "./SubTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports